import React from "react";
import { IContract, IContractLimit } from "dataModels/contract";
import "views/contractView/styles/newElementFormStyles.css";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import {v4 as uuid} from "uuid";
import { Output } from "@ds/ds-snam/react";
import { Col, Row } from "react-grid-system";
import { useSelector } from "react-redux";
import { appStore, RootState } from "state/appStore";
import { IParseDateFormatType, parseDateForDS } from "shared/utils/dateUtils";
import moment from "moment";
import { DATE_FORMAT, DsLayout, SnamPlantKey } from "shared/constants";

interface IContractLimitsProps {
    contractData: IContract
}
const ContractDataDisplay: React.FC<IContractLimitsProps> = (props): JSX.Element => {
    const { contractData } = props;
    const { t } = useTranslation(['contract']);
    const layoutMode = useSelector((state: RootState) => {
        return state.dsLayout.mode;
    });
    
    const plantIdValue: string|undefined = appStore.getState().plant.plantId;
    const renderOutput = (title: string, text: string) => {
        return <Output
            outputTitle={title}
            outputText={text}
            style={{ marginBottom: "16px" }}
        ></Output>
    }
    return (
        <>
        <div id="contractDataContainer">
                        
                        <Row style={{marginBottom:'25px',marginTop:'15px'}}>
                            <Col>
                                <Output
                                    outputTitle={t(
                                        "contract.contractData.headers.0"
                                    )}
                                    outputText={contractData.code}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                            </Col>
                            <Col>
                                <Output
                                    outputTitle={t(
                                        "contract.contractData.headers.5"
                                    )}
                                    outputText={parseDateForDS(
                                        moment
                                            .unix(contractData.startDate)
                                            .format(DATE_FORMAT),
                                        IParseDateFormatType.DATE_FORMAT1
                                    )}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                            </Col>
                            <Col>
                                <Output
                                    outputTitle={t(
                                        "contract.contractData.headers.10"
                                    )}
                                    outputText={parseDateForDS(
                                        moment
                                            .unix(contractData.endDate)
                                            .format(DATE_FORMAT),
                                        IParseDateFormatType.DATE_FORMAT1
                                    )}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                            </Col>
                            <Col>
                            </Col>
                        </Row>
                        <Row style={{marginBottom:'25px'}}>
                            <Col>
                                <Output
                                    outputTitle={t(
                                        "contract.contractData.headers.1"
                                    )}
                                    outputText={contractData.slot.toString()}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                            </Col>
                            <Col>
                                <Output
                                    outputTitle={t(
                                        "contract.contractData.headers.6"
                                    )}
                                    outputText={contractData.topPercentage.toString() + "%"}
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                            </Col>
                            <Col>
                            </Col>
                            <Col>
                            </Col>
                        </Row>
                        <Row style={{marginBottom:'25px'}}>
                            <p style={{fontSize:'120%',fontWeight:'bold',marginLeft:'15px',color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                                {t("contract.contractData.headers.2")}
                            </p>
                        </Row>
                        <Row style={{marginBottom:'25px'}}>
                            <Col>
                                {contractData.rateLoadingAvailable ?
                                   <> <Output
                                        outputTitle={t(
                                            "contract.contractData.headers.2"
                                        )}
                                        outputText={
                                            contractData.rateLoading +
                                            " " +
                                            t(
                                                "contract.contractForm.sections.dataInput.fieldDesc.0"
                                            )
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output>
                                    <div style={{marginTop:'10px'}}><Output
                                        outputTitle={t(
                                            "contract.contractData.headers.2"
                                        ) + " last minute"}
                                        outputText={
                                            contractData.rateLoadingLastMinute +
                                            " " +
                                            t(
                                                "contract.contractForm.sections.dataInput.fieldDesc.0"
                                            )
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output></div>
                                    {plantIdValue===SnamPlantKey.PIGNATARO && <>
                                        <div style={{marginTop:'10px'}}><Output
                                            outputTitle={t(
                                                "contract.contractData.headers.2"
                                            ) + " MWh"}
                                            outputText={
                                                contractData.rateLoadingMWh +
                                                " " +
                                                t(
                                                    "contract.contractForm.sections.dataInput.fieldDesc.3"
                                                )
                                            }
                                            style={{ marginBottom: "16px" }}
                                        ></Output></div>
                                        <div style={{marginTop:'10px'}}><Output
                                        outputTitle={t(
                                            "contract.contractData.headers.2"
                                        ) + " last minute MWh"}
                                        outputText={
                                            contractData.rateLoadingLastMinuteMWh +
                                            " " +
                                            t(
                                                "contract.contractForm.sections.dataInput.fieldDesc.3"
                                            )
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output></div>
                                    </>}</>
                                :
                                    <Output
                                        outputTitle={t(
                                            "contract.contractData.headers.2"
                                        )}
                                        outputText={
                                            "-"
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output>
                                }
                            </Col>
                            <Col>
                            </Col>
                            <Col>
                            </Col>
                            <Col>
                            </Col>
                        </Row>
                        <Row style={{marginBottom:'25px'}}>
                            <p style={{fontSize:'120%',fontWeight:'bold',marginLeft:'15px',color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                                {t("contract.contractData.headers.17")}
                            </p>
                        </Row>
                        <Row style={{marginBottom:'25px'}}>
                            <Col>
                                {contractData.rateLoadingBioAvailable ?
                                   /* <><Output
                                        outputTitle={t(
                                            "contract.contractData.headers.7"
                                        )}
                                        outputText={
                                            contractData.rateLoadingBio +
                                            " " +
                                            t(
                                                "contract.contractForm.sections.dataInput.fieldDesc.0"
                                            )
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output>
                                    {plantIdValue===SnamPlantKey.PIGNATARO && */
                                        <div style={{marginTop:'10px'}}><Output
                                        outputTitle={t(
                                            "contract.contractData.headers.7"
                                        ) /*+ " MWh"*/}
                                        outputText={
                                            contractData.rateLoadingBioMWh +
                                            " " +
                                            t(
                                                "contract.contractForm.sections.dataInput.fieldDesc.3"
                                            )
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output></div>
                                    /*}</>*/
                                :
                                    <Output
                                        outputTitle={t(
                                            "contract.contractData.headers.7"
                                        )}
                                        outputText={
                                            "-"
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output>
                                }
                            </Col>
                            <Col>
                                {contractData.rateCoolDownAvailable ?
                                    
                                    <>{renderOutput(t("contract.contractData.headers.11"),contractData.rateCoolDown +" "+t("contract.contractForm.sections.dataInput.fieldDesc.0"))}
                                    {plantIdValue===SnamPlantKey.PIGNATARO && 
                                        <div style={{marginTop:'10px'}}>{renderOutput(t("contract.contractData.headers.11") + " MWh",contractData.rateCoolDownMWh +" "+t("contract.contractForm.sections.dataInput.fieldDesc.3"))}</div>
                                    }</>
                                :
                                    renderOutput(t("contract.contractData.headers.11"),"-")
                                } 
                            </Col>
                            <Col>
                                {contractData.rateGasUpAvailable ?
                                    <>{renderOutput(t("contract.contractData.headers.14"),contractData.rateGasUp +" " +t("contract.contractForm.sections.dataInput.fieldDesc.0"))}
                                    {plantIdValue===SnamPlantKey.PIGNATARO && 
                                        <div style={{marginTop:'10px'}}>{renderOutput(t("contract.contractData.headers.14") + " MWh",contractData.rateGasUpMWh +" " +t("contract.contractForm.sections.dataInput.fieldDesc.3"))}</div>
                                    }</>
                                    :
                                    renderOutput(t("contract.contractData.headers.14"),"-")
                                }
                            </Col>
                            <Col>
                            </Col>
                        </Row>
                        <Row style={{marginBottom:'25px'}}>
                            <p style={{fontSize:'120%',fontWeight:'bold',marginLeft:'15px',color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                                {t("contract.contractData.headers.18")}
                            </p>
                        </Row>
                        <Row style={{marginBottom:'25px'}}>
                            <Col>
                                {contractData.rateSemiTrailerApprovalAvailable ?
                                    <><Output
                                        outputTitle={t(
                                            "contract.contractData.headers.3"
                                        )}
                                        outputText={
                                            contractData.rateSemiTrailerApproval +
                                            " " +
                                            t(
                                                "contract.contractForm.sections.dataInput.fieldDesc.0"
                                            )
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output>
                                    {plantIdValue===SnamPlantKey.PIGNATARO && 
                                        <div style={{marginTop:'10px'}}><Output
                                        outputTitle={t(
                                            "contract.contractData.headers.3"
                                        ) + " MWh"}
                                        outputText={
                                            contractData.rateSemiTrailerApprovalMWh +
                                            " " +
                                            t(
                                                "contract.contractForm.sections.dataInput.fieldDesc.3"
                                            )
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output></div>
                                    }</>
                                :
                                    <Output
                                        outputTitle={t(
                                            "contract.contractData.headers.3"
                                        )}
                                        outputText={
                                            "-"
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output>
                                }
                            </Col>
                            <Col>
                            {contractData.rateDriverApprovalAvailable ?
                                    <><Output
                                        outputTitle={t(
                                            "contract.contractData.headers.8"
                                        )}
                                        outputText={
                                            contractData.rateDriverApproval +
                                            " " +
                                            t(
                                                "contract.contractForm.sections.dataInput.fieldDesc.0"
                                            )
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output>
                                    {plantIdValue===SnamPlantKey.PIGNATARO && 
                                        <div style={{marginTop:'10px'}}><Output
                                        outputTitle={t(
                                            "contract.contractData.headers.8"
                                        ) + " MWh"}
                                        outputText={
                                            contractData.rateDriverApprovalMWh +
                                            " " +
                                            t(
                                                "contract.contractForm.sections.dataInput.fieldDesc.3"
                                            )
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output></div>
                                    }</>
                                :
                                    <Output
                                        outputTitle={t(
                                            "contract.contractData.headers.8"
                                        )}
                                        outputText={
                                            "-"
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output>
                                }
                            </Col>
                            <Col>
                                {contractData.rateSemiTrailerAndDriverApprovalAvailable ?
                                    <><Output
                                        outputTitle={t(
                                            "contract.contractData.headers.12"
                                        )}
                                        outputText={
                                            contractData.rateSemiTrailerAndDriverApproval +
                                            " " +
                                            t(
                                                "contract.contractForm.sections.dataInput.fieldDesc.0"
                                            )
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output>
                                    {plantIdValue===SnamPlantKey.PIGNATARO && 
                                        <div style={{marginTop:'10px'}}><Output
                                        outputTitle={t(
                                            "contract.contractData.headers.12"
                                        ) + " MWh"}
                                        outputText={
                                            contractData.rateSemiTrailerAndDriverApprovalMWh +
                                            " " +
                                            t(
                                                "contract.contractForm.sections.dataInput.fieldDesc.3"
                                            )
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output></div>
                                    }</>
                                :
                                    <Output
                                        outputTitle={t(
                                            "contract.contractData.headers.12"
                                        )}
                                        outputText={
                                            "-"
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output>  
                                }
                            </Col>
                            <Col>
                                {contractData.rateIsoContainerApprovalAvailable ?
                               <>{renderOutput(t("contract.contractData.headers.15"),contractData.rateIsoContainerApproval +" " +t("contract.contractForm.sections.dataInput.fieldDesc.0"))}
                                 {plantIdValue===SnamPlantKey.PIGNATARO && 
                                        <div style={{marginTop:'10px'}}>{renderOutput(t("contract.contractData.headers.15") + " MWh",contractData.rateIsoContainerApprovalMWh +" " +t("contract.contractForm.sections.dataInput.fieldDesc.3"))}</div>
                                    }</>  
                                :
                                renderOutput(t("contract.contractData.headers.15"),"-")
                                }
                            </Col>
                        </Row>
                        <Row style={{marginBottom:'25px'}}>
                            <Col>
                                {contractData.rateIsoContainerAndDriverApprovalAvailable ?
                                    <><Output
                                        outputTitle={t(
                                            "contract.contractData.headers.4"
                                        )}
                                        outputText={
                                            contractData.rateIsoContainerAndDriverApproval +
                                            " " +
                                            t(
                                                "contract.contractForm.sections.dataInput.fieldDesc.0"
                                            )
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output>
                                    {plantIdValue===SnamPlantKey.PIGNATARO && 
                                        <div style={{marginTop:'10px'}}><Output
                                        outputTitle={t(
                                            "contract.contractData.headers.4"
                                        ) + " MWh"}
                                        outputText={
                                            contractData.rateIsoContainerAndDriverApprovalMWh +
                                            " " +
                                            t(
                                                "contract.contractForm.sections.dataInput.fieldDesc.3"
                                            )
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output></div>
                                    }</>
                                :
                                    <Output
                                        outputTitle={t(
                                            "contract.contractData.headers.4"
                                        )}
                                        outputText={
                                            "-"
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output>
                                }
                            </Col>
                            <Col>
                                {contractData.rateTruckTractorApprovalAvailable ?
                                    <Output
                                        outputTitle={t(
                                            "contract.contractData.headers.9"
                                        )}
                                        outputText={
                                            contractData.rateTruckTractorApproval +
                                            " " +
                                            t(
                                                "contract.contractForm.sections.dataInput.fieldDesc.1"
                                            )
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output>
                                :
                                    <Output
                                        outputTitle={t(
                                            "contract.contractData.headers.9"
                                        )}
                                        outputText={
                                            "-"
                                        }
                                        style={{ marginBottom: "16px" }}
                                    ></Output>
                                }
                            </Col>
                            <Col>
                                {contractData.rateContainerPlatformApprovalAvailable ?
                                    <Output
                                        outputTitle={t("contract.contractData.headers.13")}
                                        outputText={contractData.rateContainerPlatformApproval +" " +t("contract.contractForm.sections.dataInput.fieldDesc.1")}
                                        style={{ marginBottom: "16px" }}
                                    ></Output>
                                :
                                    <Output
                                        outputTitle={t("contract.contractData.headers.13")}
                                        outputText={"-"}
                                        style={{ marginBottom: "16px" }}
                                    ></Output>
                                }
                            </Col>
                            <Col>
                            </Col>
                        </Row>
                        <Row style={{marginBottom:'25px'}}>
                            <p style={{fontSize:'120%',fontWeight:'bold',marginLeft:'15px',color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                                {t("contract.contractData.headers.19")}
                            </p>
                        </Row>
                        <Row style={{marginBottom:'25px'}}>
                            <Col>
                                <Output
                                    outputTitle={t(
                                        "contract.contractData.headers.16"
                                    )}
                                    outputText={
                                        contractData.fineFailureTake +
                                        " " +
                                        t(
                                            "contract.contractForm.sections.dataInput.fieldDesc.2"
                                        )
                                    }
                                    style={{ marginBottom: "16px" }}
                                ></Output>
                            </Col>
                            <Col>
                            </Col>
                            <Col>
                            </Col>
                            <Col>
                            </Col>
                        </Row>
                    </div>
        </>
    )
}
export default ContractDataDisplay